import React, { createContext } from "react";
import { List } from "@material-ui/core";

export const NavContext = createContext();

const SidebarNav = (props) => {
    const { open, children } = props;

    const ctx = {
        open,
    };

    return (
        <NavContext.Provider value={ctx}>
            <List>{children}</List>
        </NavContext.Provider>
    );
};

export default SidebarNav;
